import React from "react";
import commentimage from "../assets/comment1.jpeg";
import commentimages from "../assets/comment2.jpeg";
import avatar from "../assets/comment2avatar.jpeg";
import avatars from "../assets/comment1avatar.jpeg";
import avatarusers from "../assets/User-avatar.svg.png";





const comments = [
  {
    id: 1,
    user: "Wilma Devon",
    text: "Can anyone share their experience with this supplement?",
    timeAgo: "39 min ago",
    likes: 4,
    avatarUrl: "https://img.funnelish.com/6978/165524/1699963634-wilma-devon.jpg",
    replies: [
      {
        id: 2,
        user: "Mary Vernon",
        text: " Absolutely! This product is amazing! I struggled with losing weight for years, but now I feel lighter and more energized!",
        timeAgo: "16 min ago",
        likes: 7,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699965694-mary-vernon.jpg",
        replies: [],
      },
    ],
  },
  {
    id: 2,
    user: "Clara Milton",
    text: " I bought it and I love it! I started noticing changes in about 1-2 weeks. Didn’t expect such great results for this price!",
    timeAgo: "42 min ago",
    likes: 6,
    avatarUrl:
      "https://img.funnelish.com/19232/185804/1725461747-profile%20pc.jpg",
    replies: [],
  },
  {
    id: 3,
    user: "Doris Skylar",
    text: " I paid full price, and now it’s 40% off? That’s not fair!",
    timeAgo: "51 min ago",
    likes: 4,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699966035-doris-skylar.jpg",
    replies: [],
  },
  {
    id: 4,
    user: "Skyler Greig",
    text: " How long does shipping usually take?",
    timeAgo: "1 hr ago",
    likes: 1,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699966638-skyler-greig.jpg",
    replies: [
      {
        id: 2,
        user: "Marie Campbell",
        text: "Hey Skyler, mine took about a week to arrive!",
        timeAgo: "16 min ago",
        likes: 7,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699966838-marie-campbell.jpg",
        replies: [],
      },
    ],
  },
  // {
  //   id: 6,
  //   user: "Leonard Boyd",
  //   text: "I got this for my wife, who has struggled with weight loss. After just a few days, she already feels lighter and has more energy!",
  //   timeAgo: "1 hr ago",
  //   likes: 6,
  //   avatarUrl: avatars,
  //   imageUrl: commentimage,
  //   replies: [],
  // },
  {
    id: 7,
    user: "Emma Emerson",
    text: " That’s amazing, Leonard! So much better than those expensive diet plans!",
    timeAgo: "2 hr ago",
    likes: 2,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699967882-emma-emerson.jpg",
    replies: [
      {
        id: 2,
        user: "Lois Clive",
        text: "Wow, this is incredible! Just placed my order!",
        timeAgo: "1 hr ago",
        likes: 3,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699967979-lois-clive.jpg",
        replies: [],
      },
    ],
  },
  {
    id: 1,
    user: "Alfred Johnson",
    text: "Did you buy one? How long does it take to get results?",
    timeAgo: "2 hr ago",
    likes: 2,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699969352-alfred-johnson.jpg",
    replies: [
      {
        id: 2,
        user: "Edith Ashton",
        text: "For me, I started noticing changes in about a week!",
        timeAgo: "2 hr ago",
        likes: 5,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699969453-edith-ashton.jpg",
        replies: [],
      },
    ],
  },
  {
    id: 1,
    user: "Debra Peyton",
    text: "I should have started this sooner! I’ve been using it morning and night, and I already feel less bloated and more active!",
    timeAgo: "3 hr ago",
    likes: 1,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699969595-debra-peyton.jpg",
    replies: [],
  },
  {
    id: 2,
    user: "Paula Remington",
    text: "Wow, that sounds great! Has anyone else seen good results?",
    timeAgo: "3 hr ago",
    likes: 1,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699969688-paula-remington.jpg",
    replies: [
      {
        id: 3,
        user: "Sarah Dudley",
        text: "Yes! I’ve been using it for a few weeks now. It came well-packaged, and I’ve lost several pounds without feeling tired! 😇🔥",
        timeAgo: "2 hr ago",
        likes: 3,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699969810-sarah-dudley.jpg",
        replies: [],
      },
    ],
  },
  {
    id: 1,
    user: "Agnes Graeme",
    text: "Just ordered mine! With all the unhealthy food and stress nowadays, we all need something like this!",
    timeAgo: "3 hr ago",
    likes: 4,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699970444-agnes-graeme.jpg",
    replies: [],
  },
  {
    id: 2,
    user: "Barbara Bradly",
    text: " I want one so badly! I’ll buy it this weekend when I get paid!  😂",
    timeAgo: "3 hr ago",
    likes: 8,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699970564-barbara-bradly.jpg",
    replies: [],
  },
  {
    id: 1,
    user: "Ethel Dean",
    text: "Does anyone know how long shipping takes? I want to get one for my sister.",
    timeAgo: "4 hr ago",
    likes: 1,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699970706-ethel-dean.jpg",
    replies: [
      {
        id: 2,
        user: "Clara Milton",
        text: "Hey Ethel, mine arrived in about a week!",
        timeAgo: "2 hr ago",
        likes: 2,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699970831-clara-milton.jpg",
        replies: [],
      },
      {
        id: 3,
        user: "Emma Shelby",
        text: " Your sister will love it! Perfect gift for someone trying to lose weight!",
        timeAgo: "1 hr ago",
        likes: 2,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699970965-emma-shelby.jpg",
        replies: [],
      },
    ],
  },
  {
    id: 1,
    user: "Harry Keegan",
    text: " This is fantastic! Finally, something that actually helps me lose weight without side effects!",
    timeAgo: "4 hr ago",
    likes: 3,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699971157-harry-keegan.jpg",
    replies: [],
  },
  {
    id: 2,
    user: "Bridget Prescott",
    text: "I’m in love with this supplement! ❤️ I’ve been taking it for 20 days, and I can’t believe the difference in my energy and waistline!",
    timeAgo: "4 hr ago",
    likes: 3,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699971272-bridget-prescott.jpg",
    replies: [],
  },
  {
    id: 3,
    user: "Bridget Prescott",
    text: "I was skeptical at first, but I bought three bottles and was pleasantly surprised. This is worth every penny! It has made a huge difference!",
    timeAgo: "4 hr ago",
    likes: 3,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699971356-anna-madison.jpg",
    replies: [],
  },
  {
    id: 1,
    user: "Clara Milton",
    text: "I absolutely love this product! Had to get one for my best friend too!",
    timeAgo: "5 hr ago",
    likes: 2,
    avatarUrl:
      "https://img.funnelish.com/6978/165524/1699970831-clara-milton.jpg",
    replies: [
      {
        id: 2,
        user: "Kate Orson",
        text: "OMG, I was so happy to find it in stock today! Had to grab one before they sell out again!",
        timeAgo: "2 hr ago",
        likes: 5,
        avatarUrl:
          "https://img.funnelish.com/6978/165524/1699971615-kate-orson.jpg",
        replies: [],
      },
    ],
  },
  // {
  //   id: 6,
  //   user: "Isabella Mayson",
  //   text: "Thank you! Mine arrived today, and I can’t wait to start tonight!",
  //   timeAgo: "1 hr ago",
  //   likes: 6,
  //   avatarUrl: avatar,
  //   imageUrl: commentimages,
  //   replies: [],
  // },
];


const Comments = () => {
  const renderComment = (comment) => {
    return (
      <div
        className="flex-col justify-start items-start gap-2 flex"
        key={comment.id}
      >
        <div className="flex justify-start items-start w-full">
          <div className="flex gap-2.5">
            <div className="w-12 h-12">
              <img
                className="object-cover"
                style={{ maxWidth: "48px", height: "48px" }}
                src={comment.avatarUrl}
                alt={comment.user}
                draggable="false"
              />
            </div>
            <div className="flex-col gap-1">
              <h5 className="text-[#3b5998] text-sm font-semibold">
                {comment.user}
              </h5>
              <p className="text-gray-800 text-sm font-normal mt-1 w-full">
                {comment.text}
              </p>

              {comment.imageUrl && (
                <div className="w-40 h-40 flex justify-center items-center mt-3">
                  <img
                    className="object-cover"
                    style={{ maxWidth: "160px", height: "160px" }}
                    src={comment.imageUrl}
                    alt="Comment Image"
                    draggable="false"
                  />
                </div>
              )}
              <div className="flex items-center space-x-4 mt-1">
                <div className="flex items-center space-x-1">
                  <a className="text-xs text-gray-600 cursor-pointer">
                    {"Like"}
                  </a>
                  <span className="text-gray-400">•</span>
                  <a className="text-xs text-gray-600 cursor-pointer">
                    {"Reply"}
                  </a>
                </div>
                <div className="flex items-center gap-1">
                  <img
                    src="//img.funnelish.com/6978/165524/1699968229-thumbs-up.webp"
                    alt="Like"
                    className="w-3.5 h-3.5"
                    draggable="false"
                  />
                  <p className="text-xs text-gray-600">{comment.likes}</p>
                </div>
                <div className="flex items-center">
                  <p className="text-xs text-gray-500">{comment.timeAgo}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {comment.replies && comment.replies.length > 0 && (
          <div className="ml-14">
            {comment.replies.map((reply) => renderComment(reply))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="bg-[#f8f8f8] py-6">
      <div className="max-w-6xl mx-auto md:px-0 px-6">
        <div className="rounded-lg mt-10">
          <div className="text-lg font-semibold text-gray-700 mb-2">
            {"Comment"}
          </div>
          <textarea
            className="w-full h-28 p-4 rounded-md resize-none"
            placeholder="Add a comment"
          ></textarea>
        </div>

        <div className="w-full flex-col justify-start items-start inline-flex pt-2">
          {comments.map((comment) => renderComment(comment))}
        </div>
      </div>
    </div>
  );
};

export default Comments;
